import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const deliveryApi = createApi({
  reducerPath: 'deliveryApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Delivery'],
  endpoints: (builder) => ({
    getDeliveries: builder.query<unknown[], string | void>({
      query: (status) => ({ url: 'deliveries', params: status ? { status } : {} }),
      providesTags: ['Delivery'],
    }),
    getDelivery: builder.query<unknown, string>({
      query: (id) => `deliveries/${id}`,
      providesTags: ['Delivery'],
    }),
    createDelivery: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'deliveries', method: 'POST', body }),
      invalidatesTags: ['Delivery'],
    }),
    updateDeliveryStatus: builder.mutation<unknown, { id: string; status: string; carrier?: string }>({
      query: ({ id, ...body }) => ({ url: `deliveries/${id}/status`, method: 'PUT', body }),
      invalidatesTags: ['Delivery'],
    }),
  }),
});

export const {
  useGetDeliveriesQuery,
  useGetDeliveryQuery,
  useCreateDeliveryMutation,
  useUpdateDeliveryStatusMutation,
} = deliveryApi;
